// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/clients/clients.details/reporting/clientdetails.reporting.scss
// module id = 1138
// module chunks = 0